import React, { useEffect } from "react";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TrainingAddToCart from '../TrainingAddToCart';
import PaymentHistory from '../PaymentHistory';
import { getisEmp, getOrgType, HasScreenPermissions } from '../../../../utils/Token';
import INFO from '../../../../pages/commom/RouteUrlInfo.json';
import { useLocation } from 'react-router-dom';
import Instructions from "./Instructions";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TraningCartTabs() {
  const [value, setValue] = React.useState(0);

  const location = useLocation();

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };
  // const params = window.location.pathname
  // useEffect(() => {
  //   setValue(params == "/QuizPayments" ? 1 : 0);
  // }, [params]);

  const findFirstAccessibleTab = () => {
    if (location?.pathname.slice(1) == INFO?.MoodleAssignBulkTrainings?.actionName && getisEmp() == "true") {
      return 0;
    } else if (location?.pathname.slice(1) == INFO?.MoodleAssignBulkTrainings?.actionName) {
      return 1;
    } else if (location?.pathname.slice(1) == INFO?.QuizPayments?.actionName) {
      return 2;
    } else {
      return 1;
    }

  };

  useEffect(() => {
    const firstAccessibleTab = findFirstAccessibleTab();
    setValue(firstAccessibleTab);
  }, [INFO, location]);


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', padding: "10px", overflowX: "hidden" }}>
      <span style={{ fontSize: "28px", color: "#101828", fontWeight: "600", marginLeft: "12px" }}>Training</span>
      <Box >
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab sx={{ marginLeft: 3 }} label="Instructions" {...a11yProps(0)} hidden={HasScreenPermissions(INFO?.MoodleAssignBulkTrainings?.actionName) || getisEmp() != "true"} />
          <Tab sx={{ marginLeft: getisEmp() != "true" ? 3 : 0 }} label="Add Training Courses" {...a11yProps(1)} hidden={HasScreenPermissions(INFO?.MoodleAssignBulkTrainings?.actionName)} />
          <Tab label="Payment History" {...a11yProps(2)} hidden={HasScreenPermissions(INFO?.QuizPayments?.actionName)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0} sx={{ padding: 0 }} hidden={HasScreenPermissions(INFO?.MoodleAssignBulkTrainings?.actionName) || getisEmp() != "true"}>
        <Instructions />
      </TabPanel>
      <TabPanel value={value} index={1} sx={{ padding: 0 }} hidden={HasScreenPermissions(INFO?.MoodleAssignBulkTrainings?.actionName)}>
        <TrainingAddToCart />
      </TabPanel>
      <TabPanel value={value} index={2} hidden={HasScreenPermissions(INFO?.QuizPayments?.actionName)}>
        <PaymentHistory />
      </TabPanel>

    </Box>
  )
}
